import { makeAutoObservable } from 'mobx';
import { projectService } from '../services/ProjectService';

class AuthStore {
    isTokenSet: boolean = false;
    isInitialized: boolean = false;
    userId: string | null = null;
    organizationId: string | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    setToken(token: string) {
        projectService.setToken(token);
        this.isTokenSet = true;
    }

    setUserContext(userId: string, organizationId: string | null) {
        this.userId = userId;
        this.organizationId = organizationId;
        projectService.setUserContext(userId, organizationId);
    }

    setInitialized() {
        this.isInitialized = true;
    }

    reset() {
        this.isTokenSet = false;
        this.isInitialized = false;
        this.userId = null;
        this.organizationId = null;
    }
}

export const authStore = new AuthStore(); 